module.exports = __webpack_public_path__ + "img/icon-room-dining.36286800.svg";